<template>
  <d-card>
    <d-card-row>
      <h1 class="title is-4">
        {{ $t('onboarding.start.register.title') }}
      </h1>
      <p>
        {{ $t('onboarding.start.register.description') }}
      </p>
    </d-card-row>
    <d-card-row>
      <v-form
        :data="form"
        method="post"
        :url="$laravel.route('api.registration.register')"
        :on-success="onSuccess"
      >
        <v-input
          v-model="form.name"
          name="name"
          :autofocus="true"
        />

        <v-input-select
          v-model="form.locale"
          name="locale"
        >
          <option
            v-for="(locale, code) in $laravel.app.locales"
            :key="code"
            :value="code"
          >
            {{ locale }}
          </option>
        </v-input-select>

        <v-input
          v-model="form.email"
          type="email"
          name="email"
        />

        <v-input
          v-model="form.password"
          type="password"
          name="password"
        />

        <button class="button is-primary">
          <span>{{ $t('register') }}</span>
          <span class="icon">
            <i class="mdi mdi-arrow-right" />
          </span>
        </button>
      </v-form>
    </d-card-row>
  </d-card>
</template>

<script>
export default {
  props: {
    email: {
      default: "",
      type: String
    },
    hostType: {
      required: true,
      type: String
    },
    hostId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      form: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        locale: this.$laravel.app.locale,
        name: null,
        email: this.email,
        password: null,
        host_type: this.hostType,
        host_id: this.hostId
      }
    };
  },
  watch: {
    email () {
      this.form.email = this.email;
    }
  },
  methods: {
    onSuccess () {
      this.$refresh();
    }
  }
};
</script>
